import styled from 'styled-components';
import { resolutions } from './utils/styles';

export const AppContainer = styled.div`
  .logo-app {
    position: absolute;
    z-index: 1;
    margin: 26px 5px 40px 7px;
    display: inline-block;

  }
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  background-color: #fafafafa;
  .button-app {
    background-color: transparent;
    border: none;
    padding: 0;
  }

  .app-header {
    position: fixed;
    height: 70px;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .app-logo {
    height: 100px;
    padding-left: 110px;
    width: 100%;
    border-bottom: 2px solid #F87C56;
    background-color: white;
    font-size: 28px;
    font-weight: 500;
    padding-top: 16px;
    box-sizing: border-box;
    display: grid;
    justify-items: center;
    place-items: end;
    align-items: center;

  }

  .app-version{

    color:#848484;
    font-weight: 400;
    font-size: 14px;
    padding-right: 25px;
  }

  .app-logo img {
    height: 25px;
    display: inline-block;
    margin-left: 15px;
  }
  [class*='icon'] {
    width: 28px;
    height: 28px;
    display: inline-block;
    vertical-align: middle;
    background-size: contain;
    background-repeat: no-repeat;

    &.icon-id {
      margin-right: 10px;
      background-image: url(/assets/icon-id.png);
    }
    &.icon-user {
      margin-right: 10px;
      background-image: url(/assets/icon-user.png);
    }

    &.icon-time {
      margin-right: 10px;
      background-image: url(/assets/icon-time.png);
    }

    &.icon-copy {
      margin-right: 10px;
      background-image: url(/assets/icon-user.png);
    }
    &.icon-dashboard {
      background-image: url(/assets/img/icon-dash.svg);
      &.active {
        background-image: url(/assets/img/icon-dash-active.svg);
      }
    }
    &.icon-settings {
      background-image: url(/assets/img/icon-settings.svg);
      &.active {
        background-image: url(/assets/img/icon-settings-active.svg);
      }
    }
    &.icon-plans {
      background-image: url(/assets/img/icon-plans.svg);
      width: 28px;
      height: 28px;
      &.active {
        background-image: url(/assets/img/icon-plans-active.svg);
      }
    }
    &.icon-free {
      background-color: #F87C56;
      border-radius: 50%;
      background-image: url(/assets/img/icon-free.svg);
      background-size: 60%;
      background-position: center;
    }
    &.icon-premium {
      background-color: #F87C56;
      border-radius: 50%;
      background-image: url(/assets/img/icon-prem.svg);
      background-size: 60%;
      background-position: center;
    }
    &.icon-pro {
      background-color: #F87C56;
      border-radius: 50%;
      background-image: url(/assets/img/icon-pro.svg);
      background-size: 60%;
      background-position: center;
    }
  }
  span.spark {
    display: inline-block;
    animation: fadeIn 3.5s;
  }

  .text-red {
    color: #d12748;
  }

  .error-container {
    text-align: start;
    font-size: 14px;
    position: relative;
    top: 8px;
    margin: 0;
    margin-top: -16px;
    height: 0;
  }

  .notification-link-footer {
    position: fixed;
    height: 175px;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 2;
  }

  @keyframes blink {
    0% {
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media ${resolutions.tablet}{
    .app-logo{
      grid-template-columns: 1fr auto ;
      height: 70px;
    }


  @media ${resolutions.desktop}{
    .notification-link-footer {
      height: 80px;
    }
  }
  @media ${resolutions.desktopHD} {
    .app-logo {
      padding-left: 128px;
    }
    .error-container {
      top: 30px;
      margin-top: -24px;
    }
  }
`;

export const Spinner = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #f87c56;
  animation: spin 1s ease infinite;
`;


export const ProgressBar = styled.div`
  @keyframes progress {
    0% {
      width: 0;
      background: #909090;
    }

    50% {
      width: 30%;
      background: #909090;
    }

    100% {
      width: 100%;
      background: #909090;
    }
  }
  position: relative;
  display: inline-block;
  margin-left: 40%;
  margin-top: 20%;
  width: 300px;
  height: 5px;
  background: #dedede;
  border-radius: 4px;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 4px;
    animation: progress 10s infinite;
  }
`;

export const ProgressBarModal = styled.div`
  @keyframes progress {
    0% {
      width: 0;
      background: #909090;
    }

    50% {
      width: 30%;
      background: #909090;
    }

    100% {
      width: 100%;
      background: #909090;
    }
  }
  position: relative;
  display: inline-block;
  margin-top: 20%;
  width: 300px;
  height: 5px;
  background: #dedede;
  border-radius: 4px;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 4px;
    animation: progress 10s infinite;
  }
`;

export const VerificationSpinner = styled.div`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 30px;
  height: 30px;
  align-items: center;
  border-radius: 50%;
  border-left-color: #666666;
  animation: spin 1s ease infinite;
`;
